define(["require", "exports", "./between", "./blank", "./callback", "./choice", "./creditCard", "./date", "./different", "./digits", "./emailAddress", "./file", "./greaterThan", "./identical", "./integer", "./ip", "./lessThan", "./notEmpty", "./numeric", "./promise", "./regexp", "./remote", "./stringCase", "./stringLength", "./uri"], function (require, exports, between_1, blank_1, callback_1, choice_1, creditCard_1, date_1, different_1, digits_1, emailAddress_1, file_1, greaterThan_1, identical_1, integer_1, ip_1, lessThan_1, notEmpty_1, numeric_1, promise_1, regexp_1, remote_1, stringCase_1, stringLength_1, uri_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        between: between_1.default,
        blank: blank_1.default,
        callback: callback_1.default,
        choice: choice_1.default,
        creditCard: creditCard_1.default,
        date: date_1.default,
        different: different_1.default,
        digits: digits_1.default,
        emailAddress: emailAddress_1.default,
        file: file_1.default,
        greaterThan: greaterThan_1.default,
        identical: identical_1.default,
        integer: integer_1.default,
        ip: ip_1.default,
        lessThan: lessThan_1.default,
        notEmpty: notEmpty_1.default,
        numeric: numeric_1.default,
        promise: promise_1.default,
        regexp: regexp_1.default,
        remote: remote_1.default,
        stringCase: stringCase_1.default,
        stringLength: stringLength_1.default,
        uri: uri_1.default,
    };
});
